import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-date-component',
  templateUrl: './date-component.component.html',
  styleUrls: ['./date-component.component.scss'],
})
export class DateComponentComponent implements OnInit {

  @Input() currDate : Date;
  
  constructor(public modalController: ModalController,) { }

  ngOnInit() {
  }

  confirm(event){
    this.modalController.dismiss(event);
  }

}
